<template>
  <div
    class="absolute top-0 left-0 text-card-forecolor m-4 w-full"
    :class="getLocale() === 'ar' ? 'pr-8' : ''"
    style="text-shadow: 0 0 1ex black">
    <h2 class="text-md lg:text-xl lg:text-2xl pb-1 lg:pb-4 font-semibold w-3/5 lg:w-3/5">{{ text }}</h2>
    <slot />
  </div>
</template>

<script setup>
import { getLocale } from "@/components/page/menu/locales.js";
defineProps({
  text: { required: true },
});
</script>
